import React from 'react';

import { useClassName } from 'common/hooks';
import { CustomTabs } from 'public/components/Tabs';
import VenueBreadcrumb from 'public/components/Breadcrumb';
import { jumpTo } from 'utils/helpers/scroll';
import { CTA_TYPES, STANDARD_EVENTS } from 'utils/analytics/trackV2';

import Link from '../Link';
import useCustomStyle from '../../hooks';

import './breadcrumbs.less';
import ParkScreenBreadcrumb from '../ParkScreenBreadcrumb/ParkScreenBreadcrumb';
import { getContentfulField } from 'common/components';

export default function Breadcrumbs({
  component,
  refs,
  featuredFlags,
  openingHours,
  isDateUnavailable,
  openingHoursBanner,
  venueParkAccessMessage = '',
  ticketOptions = [],
  handleTrack = undefined,
  ridesCards = [],
  venueSlug = '',
  venueId,
  emptyAsset,
  emptyAssetStyle,
}) {
  const classNames = useClassName('CLPBreadcrumbs');
  const [setRef] = useCustomStyle(component.fields.settings);

  const onClickTab = (item) => {
    if (item.sys.contentType.sys.id === 'keyValue') {
      if (handleTrack) {
        handleTrack({
          event: STANDARD_EVENTS.click,
          params: {
            label: item.fields.key,
            cta_type: CTA_TYPES.jump,
          },
        });
      }
      jumpTo(item.fields.value, refs);
    }
  };

  if (component.fields.type === 'Type B') {
    return (
      <VenueBreadcrumb
        links={component.fields.items.map((item) => ({
          url: item.fields.value,
          title: item.fields.key,
        }))}
        className={classNames('type-b')}
      />
    );
  }

  if (component.fields.type === 'Type C') {
    return (
      <ParkScreenBreadcrumb
        links={component.fields.items.map((item) => {
          const isOpenHours = item.sys?.contentType?.sys?.id === 'lpOpenHours';
          const isButtonTicket =
            item.sys?.contentType?.sys?.id === 'lpButtonTicket';

          return {
            url: item.fields.url,
            title: item.fields.label || getContentfulField(item.fields.title),
            icon: item.fields.icon,
            type: isOpenHours
              ? 'open-hours'
              : isButtonTicket
              ? 'button-ticket'
              : 'default',
          };
        })}
        className={classNames('type-c')}
        featuredFlags={featuredFlags}
        openingHours={openingHours}
        isDateUnavailable={isDateUnavailable}
        openingHoursBanner={openingHoursBanner}
        venueParkAccessMessage={venueParkAccessMessage}
        ticketOptions={ticketOptions}
        ridesCards={ridesCards}
        venueSlug={venueSlug}
        venueId={venueId}
        emptyAsset={emptyAsset}
        emptyAssetStyle={emptyAssetStyle}
      />
    );
  }

  return (
    <CustomTabs
      fixed
      styles={{
        container: classNames('container'),
      }}
      refs={refs}
      ref={setRef}>
      {component.fields.items.map((item) => {
        if (item.sys.contentType.sys.id === 'keyValue') {
          return (
            <span
              key={item.sys.id}
              name={item.fields.value}
              onClick={() => onClickTab(item)}>
              {item.fields.key}
            </span>
          );
        }

        return (
          <Link
            key={item.sys.id}
            component={item}
            refs={refs}
            handleTrack={handleTrack}
          />
        );
      })}
    </CustomTabs>
  );
}
